/* fogd. footer accordion - active on mobile only */
(function () {
  var mq = window.matchMedia('(max-width:760px)');
  function setup() {
    document.querySelectorAll('footer .fcol').forEach(function (c) {
      var h = c.querySelector('h4');
      if (!h) return;
      if (mq.matches) {
        c.classList.add('js-acc');
        h.setAttribute('role', 'button');
        h.setAttribute('tabindex', '0');
        h.setAttribute('aria-expanded', c.classList.contains('is-open') ? 'true' : 'false');
      } else {
        c.classList.remove('js-acc', 'is-open');
        h.removeAttribute('role');
        h.removeAttribute('tabindex');
        h.removeAttribute('aria-expanded');
      }
    });
  }
  function toggle(h) {
    var c = h.closest('.fcol');
    if (!c) return;
    var open = c.classList.toggle('is-open');
    h.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('footer .fcol h4');
    if (h && mq.matches) toggle(h);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var h = e.target.closest && e.target.closest('footer .fcol h4');
    if (h && mq.matches) { e.preventDefault(); toggle(h); }
  });
  if (mq.addEventListener) mq.addEventListener('change', setup); else if (mq.addListener) mq.addListener(setup);
  setup();
})();
